import i18next from 'i18next'

export const getCurrentLanguage = () => i18next.language
